import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './Toggle.css';

var Toggle = /*#__PURE__*/function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Toggle);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Toggle)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      isChecked: false
    }, _this.onChange = function (event) {
      var _this$props = _this.props,
          name = _this$props.name,
          handleChange = _this$props.handleChange,
          input = _this$props.input;

      _this.setState({
        isChecked: !_this.state.isChecked
      });

      if (handleChange) {
        handleChange(name);
      }

      if (input && input.onChange) {
        input.onChange(event.target.checked);
      }
    }, _temp));
  }

  _createClass(Toggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.initialChecked) {
        this.setState({
          isChecked: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          noTranslate = _this$props2.noTranslate,
          _this$props2$disabled = _this$props2.disabled,
          disabled = _this$props2$disabled === void 0 ? false : _this$props2$disabled,
          input = _this$props2.input;
      var noTranslateAttr = noTranslate && {
        notranslate: 'true'
      };
      var disabledAttr = disabled && {
        disabled: true
      };
      return React.createElement('label', _extends({
        className: 'Toggle'
      }, noTranslateAttr, disabledAttr), React.createElement('input', _extends({
        type: 'checkbox',
        name: name,
        checked: this.state.isChecked,
        onChange: this.onChange,
        disabled: disabled
      }, input)), React.createElement('span', {
        className: 'slider round'
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var checked = nextProps.checked;
      return checked === undefined ? null : {
        isChecked: checked
      };
    }
  }]);

  return Toggle;
}(Component);

Toggle.propTypes = {
  name: PropTypes.string,
  noTranslate: PropTypes.bool,
  disabled: PropTypes.bool,
  input: PropTypes.any,
  checked: PropTypes.bool,
  handleChange: PropTypes.func,
  initialChecked: PropTypes.bool
};
Toggle.defaultProps = {
  disabled: false,
  initialChecked: false
};
export default Toggle;